import { render, staticRenderFns } from "./prevention_cure.vue?vue&type=template&id=fcaf37ba&"
import script from "./prevention_cure.vue?vue&type=script&lang=js&"
export * from "./prevention_cure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports